<template>
  <div class="split-block" :class="{ 'is-border': border }">
    <span class="prompt-block"></span>
    <span>{{split.text}}</span>
  </div>
</template>

<script>
export default {
  name: "split-block",
  props: {
    split: {
      type: Object,
      default: function () {
        return {
          text: '标题'
        }
      }
    },
    border: {
      type: Boolean,
      default: true,
    },
  }
}
</script>


<style scoped lang="stylus" >
$color-theme = #e96558
.split-block
  display: flex
  align-items: center
  padding: 10px 0
  &.is-border
    border-bottom: 1px solid #dcdfe6
  span
    font-size: 16px
    color: #000
    font-weight 600


.prompt-block
  width: 4px
  height: 14px
  margin-right: 6px
  background: $color-theme
</style>
